import { useMemo } from "react";
import { useSelector } from "react-redux";
import SelectAutoInput from "./SelectAutoInput";
import { useEnsureUsers } from "../../hooks/useEnsureReferenceData";

const SelectUserEmailInput = ({
  value,
  onChange,
  fullWidth = true,
  sx,
  options,
  size = "medium",
  placeholder,
  label,
  displayFullLabel = false,
  error,
  helperText,
}) => {
  // The picker's options come from the shared `users` slice. Ensure it's loaded
  // whenever this input is on screen (cache-gated — no-op if already present),
  // so e.g. a support ticket's "Assigned to" autocomplete has options even on a
  // page that doesn't otherwise pull users.
  useEnsureUsers();
  // Find the "selected" option object whose .value matches `value`.
  const users = useSelector((state) => state?.users);
  const selectOptionsUserEmailOptions = useMemo(
    () =>
      (users || [])
        .map((user) => ({
          // label: user?.fullName,
          label: displayFullLabel
            ? `${user?.fullName} <${user?.emailAddress}>`
            : user?.fullName,
          optionLabel: `${user?.fullName} <${user?.emailAddress}>`,
          value: user?.emailAddress,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [users, displayFullLabel]
  );
  return (
    <SelectAutoInput
      label={label}
      value={value}
      options={selectOptionsUserEmailOptions}
      onChange={onChange}
      error={error}
      helperText={helperText}
    />
  );
};

export default SelectUserEmailInput;
